<template>
  <van-popup round v-model="popupVisible" position="bottom" @closed="$emit('close')" style="max-height: 70%">
    <div class="vote-answer more-rank" style="padding: 16px">
      <div style="margin-bottom: 12px;" class="text-center">
        {{question.content.text}}
      </div>
      <div class="more-rank-content">
        <choice-vote-content :items="items" :show-count="-1"/>
      </div>
    </div>
  </van-popup>
</template>

<script>
import ChoiceVoteContent from './ChoiceVoteContent.vue'

export default {
  name: 'ChoiceMoreRank',
  components: { ChoiceVoteContent },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    question: {
      type: Object
    }
  },
  data() {
    return {
      popupVisible: false
    }
  },
  mounted() {
    this.popupVisible = true
  }
}
</script>

<style scoped lang="scss">
.more-rank {
  background-color: #F5F5F5;
  margin-top: 0;
  
  .more-rank-content {
    background-color: #fff;
    padding: 12px;
  }
}
</style>